import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import useApi from '../hooks/useApi';
import UserService from '../services/user.service';
import { Accordion, AccordionDetails, AccordionSummary, Box, createTheme, IconButton, ListSubheader, Menu, MenuItem, MenuList, Tab, Tabs, ThemeProvider, Typography } from '@mui/material';
import { ExpandMoreOutlined, Menu as MenuIcon, MenuOpen as MenuOpenIcon } from '@mui/icons-material';
import LanguageSwitcher from './LanguageSwitcher';
import { useTranslation } from 'react-i18next';
import NotificationService from '../services/notification.service';
import useLogout from '../hooks/useLogout';
const MenuHeader = () => {
  const { t } = useTranslation('menu');
  const theme = createTheme({
    palette: {
      primary: {
        main: '#eedd5f'
      },
      secondary: {
        main: 'rgba(57, 61, 68, 1)'
      }
    }
  })
  const [selected, setSelected] = useState('home');
  const [user, setUser] = useState();
  const logout = useLogout();

  const { auth } = useAuth();
  
  const api = useApi();
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [burgerMenuVisible, setBurgerMenuVisible] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const isEditMode = !!sessionStorage.getItem('editBookingMode');

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const toggleBurgerMenu = () => {
    setBurgerMenuVisible(!burgerMenuVisible);
  };

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getUsers = async () => {
      try {

        // const response = await axiosPrivate.get(endpoints.getProfil);
        const response = await UserService.currentUser({ with: 'notifications' }, api)
        console.log("usersss", response)
        if (response?.user?.status === 'PENDING_PHONE_VERIFICATION') {
          logout();
          navigate("/login");
        }
        if (isMounted) {
          setUser(response);
          setUnreadCount(response?.user?.notifications?.filter(
            (notification) => notification.is_read !== "1"
          ).length || 0);
        }
      } catch (err) {
        console.error(err);
      }
    };

    if (!auth || Object.keys(auth).length === 0) {
      return;
    }
    getUsers();
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [auth]);




  const [selectedTab, setSelectedTab] = React.useState(0);
  const tabs = [
    { label: t('home'), link: '/' },
    { label: t('services'), sub_tabs: [{ label: t('choose_your_service'), link: '/choose-location' }, { label: t('choose_partner_hotel'), link: '/hotels' }] },
    { label: t('flypro'), link: '/location-pro' },
    { label: t('orders'), link: '/commande' },
    { label: t('gifts'), link: '/gifts' },
    { label: t('contact'), link: '/contact' },
  ];
  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };


  useEffect(() => {
    const path = window.location.pathname;
    const index = tabs.findIndex((tab) => tab?.link === path || tab.sub_tabs?.find((sub_tab) => sub_tab.link === path));
    setSelectedTab(index === -1 ? 0 : index);
  }, [window.location.pathname]);

  const TabWithSubs = ({ tab, index }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    }
    const handleClose = () => {
      setAnchorEl(null);
    }
    return (
      <>
        <Tab wrapped={true} label={tab.label} icon={<img src='assets/images/arrow_down.svg' />} iconPosition='end' value={index} onClick={handleClick} sx={{ fontSize: '14px', opacity: 1, height: '100%' }} />
        <Menu
          id="sub-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          color='secondary'
          onClose={handleClose}
        >
          {tab.sub_tabs.map((sub_tab, sub_index) => (
            <MenuItem
              key={sub_index}
              onClick={() => {
                handleClose();
                if (!isEditMode) {
                  sessionStorage.clear();
                }
                navigate(sub_tab.link);
              }}
            >
              {sub_tab.label}
            </MenuItem>
          ))}
        </Menu>
      </>
    )
  }

  const MenuWithSubs = ({ tab, index }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    }
    const handleClose = () => {
      setAnchorEl(null);
    }
    return (
      <>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreOutlined />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography component="span">{tab?.label}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {tab?.sub_tabs.map((sub_tab, sub_index) => (
              <MenuItem key={sub_index} onClick={() => {
                if (!isEditMode) {
                  sessionStorage.clear();
                }
                handleClose();
                navigate(sub_tab.link);
              }}>
                {sub_tab.label}
              </MenuItem>
            ))}
          </AccordionDetails>
        </Accordion>
        {/* <MenuItem label={tab.label} icon={<img src='assets/images/arrow_down.svg' />} iconPosition='end' value={index} onClick={handleClick} sx={{ height: '100%' }} >
          {tab.label} <img src='assets/images/arrow_down.svg' />
        </MenuItem> */}
      </>
    )
  }
  const navigate = useNavigate();
  const markNotificationsAsRead = async () => {
    try {
      await NotificationService.markAllNotificationsAsRead(api);
      setUnreadCount(0);
    } catch (error) {
      console.error("Error marking notifications as read:", error);
    }
  };

  const handleNotificationClick = (e) => {
    e.preventDefault(); // Prevent default link behavior
    markNotificationsAsRead();
    navigate('/notifications');
  };
  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);

  const handleMenuClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  }
  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  }
  return (
    <div className="menu-header">
      <Box sx={{ width: 'fit-content', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }} className='menu-header-mobile'>
        <IconButton onClick={handleMenuClick}>{Boolean(menuAnchorEl) ? (<MenuOpenIcon />) : (<MenuIcon />)}</IconButton>
        <Link to='/'><img src='assets/images/logo.svg' alt='FlySpa Logo' className='logo' /></Link>
        <Menu
          id="menu"
          anchorEl={menuAnchorEl}
          open={Boolean(menuAnchorEl)}
          onClose={handleMenuClose}
        >
          <Box sx={{ padding: '0 10px' }}>
            {tabs.map((tab, index) => (
              tab.sub_tabs?.length ? (
                <MenuWithSubs key={index} tab={tab} index={index} />
              ) : (
                <MenuItem key={index} onClick={() => { handleMenuClose(); navigate(tab?.link) }}>
                  {tab.label}
                </MenuItem>
              )
            ))}
          </Box>

        </Menu>
      </Box>


      <div className="menu">
        <div className="menu-left">
          <ThemeProvider theme={theme}>
            <Box sx={{ width: 'fit-content', margin: '0 auto', height: '100%' }}>
              <Tabs
                value={selectedTab}
                onChange={handleChange}
                indicatorColor='primary'
                textColor='secondary'
                defaultValue={0}
                sx={{ height: '100%' }}
              >
                {tabs.map((tab, index) => tab.sub_tabs?.length ? (
                  <TabWithSubs key={index} tab={tab} />
                ) : (
                  <Tab
                    key={index}
                    label={tab.label}
                    value={index}
                    sx={{ height: '100%' }}
                    onClick={e => {
                      e.preventDefault();
                      if (!isEditMode) {
                        sessionStorage.clear();
                      }
                      navigate(tab.link);
                    }}
                  />
                ))}
              </Tabs>
            </Box>
          </ThemeProvider>
        </div>
        {user && (
          <div className="menu-right">
            <ul>
              <li><LanguageSwitcher compact /></li>
              <li><Link to="/notifications" className="notif" onClick={handleNotificationClick}><span>{unreadCount}</span></Link></li>
              <li><Link to="/Profile" className="account">{user?.user?.extra?.initials}</Link></li>
            </ul>
          </div>
        )} {!user && (
          <div className="menu-right">
            <ul>
              <li><LanguageSwitcher compact /></li>
              <li><Link to="/login" className="login"><img src='assets/images/icon-login.svg' alt='login' /></Link></li>
            </ul>
          </div>
        )}
      </div>
    </div >
  );
}

export default MenuHeader;
